import React, { useEffect, useState, useContext } from 'react'

import useAppState from 'hooks/useAppState'
import useChartsStore from 'hooks/useChartsStore'
import useCrossfilterStore from 'hooks/useCrossfilterStore'
import useNotificationsStore from 'hooks/useNotificationsStore'
import useAudienceState from 'hooks/useAudienceState'
import useCommand from 'hooks/useCommand'
import useQuery from 'hooks/useQuery'
import ErrorContext from 'ErrorContext'

const SessionContext = React.createContext(null)
export default SessionContext

export function useSession(){

    const [explorerModule, setExplorerModule] = useState(
        localStorage.getItem("am:explorer_module") || "consumers"
    );

    const [ loaded, setLoaded ] = useState(false)

    const appState = useAppState()

    const audienceSaved = useAudienceState()

    const errorContext = useContext(ErrorContext);

    const command = useCommand(appState)
    const query = useQuery(appState)

    const chartsStore = useChartsStore(appState, query, explorerModule)
    const crossfilterStore = useCrossfilterStore(appState, chartsStore, command, query)
    const notificationsStore = useNotificationsStore()

    useEffect(() => {
        if (crossfilterStore.explorerModule && crossfilterStore.explorerModule !== explorerModule) {
            setExplorerModule(crossfilterStore.explorerModule);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [crossfilterStore.explorerModule])

    const session = {
        loaded: loaded,
        query: query,
        command: command,
        appState: appState,
        audienceSaved: audienceSaved,
        chartsStore: chartsStore,
        crossfilterStore : crossfilterStore,
        notificationsStore: notificationsStore,
        errorContext: errorContext,
    }

    useEffect( ()=> {
        if (!loaded &&
            crossfilterStore.loaded && chartsStore.loaded && appState.loaded) {
            setLoaded(true)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [crossfilterStore.loaded, chartsStore.loaded, appState.loaded])

    return session
}
